import React, { useEffect, useState } from "react";
import {Container, Button, Offcanvas, Row, Col, Form, Badge} from "react-bootstrap";
import {CopyToClipboard} from "react-copy-to-clipboard";
import share from "../assets/icons/share.svg";
import save from "../assets/icons/save.svg";
import { compressToEncodedURIComponent } from "lz-string";

const Menu = (props) => {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [shareText, setShareText] = useState('');
    const [copied, setCopied] = useState(false);
    const [showShare, setShowShare] = useState(false);
    const handleCloseShare = () => {
        setCopied(false);
        setShowShare(false);
    };
    const handleShowShare = () => {
        let build = {
            ninja1: props.ninja1,
            ninja1Relics: props.ninja1Relics,
            ninja2: props.ninja2,
            ninja2Relics: props.ninja2Relics,
        };
        let buildString = JSON.stringify(build, null, null);
        let encodedBuild = compressToEncodedURIComponent(buildString);
        let path = window.location.href + '?build=' + encodedBuild;
        setShareText(path);
        setShowShare(true);
    };

    const [localStorageKeys, setLocalStorageKeys] = useState([]);
    const [buildNameForLoad, setBuildNameForLoad] = useState('');
    const [buildNameForSave, setBuildNameForSave] = useState('');

    useEffect(() => {
        setLocalStorageKeys(Object.keys(localStorage));
    }, []);

    const handleSaveNinja1 = () => {
        saveBuild(props.ninja1Relics);  
    };

    const handleSaveNinja2 = () => {
        saveBuild(props.ninja2Relics);  
    };

    const saveBuild = (relics) => {
        let localStorageKey = 'build_' + buildNameForSave;
        localStorage.setItem(localStorageKey, JSON.stringify(relics));
        setLocalStorageKeys(Object.keys(localStorage));
        setBuildNameForSave('');
    };

    const handleDelete = () => {
        let localStorageKey = 'build_' + buildNameForLoad;
        localStorage.removeItem(localStorageKey);
        setLocalStorageKeys(Object.keys(localStorage));
    };

    const handleDeleteAll = () => {
        Object.keys(localStorage).map((key) => {
            if (key.startsWith('build_'))
            {
                localStorage.removeItem(key);
            }
        });
        setLocalStorageKeys([]);
    };

    const handleLoadNinja1 = () => {
        let relics = getRelicsFromLocalStorage();
        props.setNinja1Relics(relics);
    };

    const handleLoadNinja2 = () => {
        let relics = getRelicsFromLocalStorage();
        props.setNinja2Relics(relics);
    };

    const getRelicsFromLocalStorage = () => {
        let localStorageKey = 'build_' + buildNameForLoad;
        let localStorageValue = localStorage.getItem(localStorageKey);
        let relics = JSON.parse(localStorageValue);
        return relics;
    };

    return (
        <Container className="p-1 d-flex justify-content-center">
            <Row>
                <Col>
                    <Button size={"sm"} variant={"outline-primary"} onClick={handleShow}><img src={save} width={15}/></Button>
                </Col>
                <Col>
                    <Button size={"sm"} variant={"outline-primary"} onClick={handleShowShare}><img src={share} width={15}/></Button>
                </Col>
            </Row>

            <Offcanvas show={show} onHide={handleClose} placement={"top"}>
                <Offcanvas.Header closeButton  className="pt-0 pb-0">
                    <Offcanvas.Title>Load</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Row>
                        <Col xs={6} lg={3}>
                            <Form.Select size="sm" value={buildNameForLoad} onChange={(e) => setBuildNameForLoad(e.target.value)}>
                                <option>Select Build...</option>
                                {
                                    localStorageKeys.map((key, index) => {
                                        if (key.startsWith('build_'))
                                        {
                                            let name = key.substring(6);
                                            return <option key={index} value={name}>{name}</option>
                                        }
                                    })
                                }
                            </Form.Select>
                        </Col>
                        <Col xs={3}>
                            <Button variant="outline-primary" size="sm" onClick={handleLoadNinja1}>Ninja 1</Button>
                        </Col>
                        <Col xs={3}>
                            <Button variant="outline-danger" size="sm" onClick={handleDelete}>Delete</Button>
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col xs={6} lg={3}/>
                        <Col xs={3}>
                            <Button variant="outline-primary" size="sm" onClick={handleLoadNinja2}>Ninja 2</Button>
                        </Col>
                        <Col xs={3}>
                            <Button variant="outline-danger" size="sm" onClick={handleDeleteAll}>Delete All</Button>
                        </Col>
                    </Row>
                </Offcanvas.Body>
                <Offcanvas.Header className="pt-0 pb-0">
                    <Offcanvas.Title>Save</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Row>
                        <Col xs={6} lg={3}>
                            <Form.Control size="sm" placeholder="Build Name" value={buildNameForSave} onChange={(e) => setBuildNameForSave(e.target.value)}/>
                        </Col>
                        <Col xs={3}>
                            <Button variant="outline-primary" size="sm" onClick={handleSaveNinja1}>Ninja 1</Button>
                        </Col>
                    </Row>
                    <Row className="pt-2">
                        <Col xs={6} lg={3}/>
                        <Col xs={3}>
                            <Button variant="outline-primary" size="sm" onClick={handleSaveNinja2}>Ninja 2</Button>
                        </Col>
                    </Row>
                </Offcanvas.Body>
            </Offcanvas>

            <Offcanvas show={showShare} onHide={handleCloseShare} placement={"top"}>
                <Offcanvas.Header closeButton  className="pt-0 pb-0">
                    <Offcanvas.Title>Share</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="selection">
                    <Row>
                        <Col>Copy a direct link to the current build comparison.
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <CopyToClipboard text={shareText} onCopy={() => setCopied(true)}>
                                <Button variant="outline-primary" size="sm">Copy to Clipboard</Button>
                            </CopyToClipboard>
                            {copied ? <Badge bg="success">Copied!</Badge> : null}
                        </Col>
                    </Row>
                </Offcanvas.Body>
            </Offcanvas>
        </Container>
    );
};

export default Menu;